import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Archive from "@/pages/Archive";
import ArchiveDetail from "@/pages/ArchiveDetail";
import Upload from "@/pages/Upload";
import Settings from "@/pages/Settings";
import DevDashboard from "@/pages/DevDashboard";
import Template from "@/pages/Template";
import AktaTemplate from "@/pages/AktaTemplate";
import TemplateKuitansi from "@/pages/TemplateKuitansi";
import TemplateTandaTerima from "@/pages/TemplateTandaTerima";
import TemplateSuratKeterangan from "@/pages/TemplateSuratKeterangan";
import TemplateCovernote from "@/pages/TemplateCovernote";
import TemplateRincianBiaya from "@/pages/TemplateRincianBiaya";
import BuatDokumen from "@/pages/BuatDokumen";
import Invoice from "@/pages/Invoice";
import Pajak from "@/pages/Pajak";
import Pengingat from "@/pages/Pengingat";
import AdminLogs from "@/pages/AdminLogs";
import AdminStaff from "@/pages/AdminStaff";
import Explorer from "@/pages/Explorer";
import FileEditor from "@/pages/FileEditor";
import QR from "@/pages/QR";
import QRVerify from "@/pages/QRVerify";
import Klapper from "@/pages/Klapper";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-[#555]" data-testid="auth-loading">
        Memuat…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function DeveloperRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-[#555]">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "developer") return <Navigate to="/" replace />;
  return children;
}

function DevRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-[#555]">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "developer") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/qr/verify/:id" element={<QRVerify />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/arsip" element={<Archive />} />
                <Route path="/arsip/:id" element={<ArchiveDetail />} />
                <Route path="/upload" element={<Upload />} />
                <Route path="/template" element={<Template />} />
                <Route path="/template-akta" element={<AktaTemplate />} />
                <Route path="/template-kuitansi" element={<TemplateKuitansi />} />
                <Route path="/template-tanda-terima" element={<TemplateTandaTerima />} />
                <Route path="/template-surat-keterangan" element={<TemplateSuratKeterangan />} />
                <Route path="/template-covernote" element={<TemplateCovernote />} />
                <Route path="/template-rincian-biaya" element={<TemplateRincianBiaya />} />
                <Route path="/buat-dokumen" element={<BuatDokumen />} />
                <Route path="/invoice" element={<Invoice />} />
                <Route path="/pajak" element={<Pajak />} />
                <Route path="/pengingat" element={<Pengingat />} />
                <Route path="/qr" element={<QR />} />
                <Route path="/klapper" element={<Klapper />} />
                <Route path="/explorer" element={<Explorer />} />
                <Route path="/explorer/edit" element={<FileEditor />} />
                <Route path="/developer/logs" element={<DeveloperRoute><AdminLogs /></DeveloperRoute>} />
                <Route path="/developer/staff" element={<DeveloperRoute><AdminStaff /></DeveloperRoute>} />
                <Route path="/dev" element={<DevRoute><DevDashboard /></DevRoute>} />
                <Route path="/pengaturan" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
